<div class="audio-player" [class.audio-player--compact]="compact()">
  <button
    type="button"
    appUiIconButton
    variant="accent"
    shape="pill"
    size="sm"
    class="audio-player__play"
    [attr.aria-label]="isPlaying() ? 'Pausar áudio' : 'Tocar áudio'"
    [disabled]="!loaded()"
    (click)="toggle()"
  >
    <ng-icon [name]="isPlaying() ? 'heroPauseSolid' : 'heroPlaySolid'" size="18" aria-hidden="true" />
  </button>

  <div class="audio-player__body">
    <div
      class="audio-player__progress"
      role="slider"
      tabindex="0"
      [attr.aria-valuemin]="0"
      [attr.aria-valuemax]="duration()"
      [attr.aria-valuenow]="currentTime()"
      [attr.aria-label]="'Posição do áudio'"
      (click)="seek($event)"
      (keydown)="onProgressKeydown($event)"
    >
      <div class="audio-player__progress-bar" [style.width.%]="progressPct()"></div>
      <div class="audio-player__progress-thumb" [style.left.%]="progressPct()"></div>
    </div>
    <div class="audio-player__footer">
      <ng-icon name="heroMicrophone" size="12" class="audio-player__mic" aria-hidden="true" />
      <time class="audio-player__time">{{ displayTime() }}</time>
    </div>
  </div>

  <button
    type="button"
    appButton
    variant="ghost"
    size="sm"
    class="audio-player__speed"
    [class.audio-player__speed--active]="playbackRate() !== 1"
    [attr.aria-label]="'Velocidade ' + playbackRate() + 'x'"
    [disabled]="!loaded()"
    (click)="cycleSpeed()"
  >
    {{ playbackRate() }}×
  </button>

  <audio
    #audio
    [src]="src()"
    preload="metadata"
    (loadedmetadata)="onLoadedMetadata()"
    (timeupdate)="onTimeUpdate()"
    (play)="onPlay()"
    (pause)="onPause()"
    (ended)="onEnded()"
  ></audio>
</div>
